export default __webpack_public_path__ + "static/media/fr3.faf316bc.jpg";